import { mapDeviceModelFromSysApi } from '@shure/cloud/device-management/devices/data-access';
import { DeviceClaimProgress, DeviceDetection } from '@shure/cloud/shared/models/devices';
import { DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceNameCellData } from '@shure/shared/angular/ui/components/ag-grid-next';

import { ClaimStatusCellData, mapClaimResultToProgressCellData } from './claim-status-cell-data';

export interface LocalNetworkConfirmationTableRowData {
	id: string;
	nameCellData: DeviceNameCellData;
	claimStatusCellData: ClaimStatusCellData;
	model: string;
	ipAddress: string;
	firmwareVersion: string;
	macAddress: string;
}

export function mapDevicesToClaimDataToLocalNetworkConfirmationTableRowData(
	data: DeviceClaimProgress<DeviceDetection>['devices'][0][]
): LocalNetworkConfirmationTableRowData[] {
	return data.map((d) => mapDeviceToClaimToLocalNetworkConfirmationTableRowData(d));
}

function mapDeviceToClaimToLocalNetworkConfirmationTableRowData(
	deviceData: DeviceClaimProgress<DeviceDetection>['devices'][0]
): LocalNetworkConfirmationTableRowData {
	// for nameCellData, only the id, name and model matter here since we don't have the other ones in our device in this case
	const nameCellData: DeviceNameCellData = {
		id: deviceData.device.device.id,
		model: mapDeviceModelFromSysApi(deviceData.device.device.model),
		status: DeviceStatus.Discovered,
		isVirtual: false,
		isPasswordEnabled: false,
		isAuthenticated: false,
		name: {
			name: deviceData.device.device.name,
			isDisabled: false
		}
	};

	const claimStatusCellData: ClaimStatusCellData = {
		id: deviceData.device.device.id,
		...mapClaimResultToProgressCellData(deviceData.result)
	};

	const rowData: LocalNetworkConfirmationTableRowData = {
		id: deviceData.device.device.id,
		nameCellData,
		claimStatusCellData,
		model: deviceData.device.device.model,
		ipAddress: deviceData.device.device.ipAddress,
		firmwareVersion: deviceData.device.device.firmwareVersion,
		macAddress: deviceData.device.device.macAddress
	};

	return rowData;
}
